/**
 * The organic marker: a leaf for a *biologisch* product.
 *
 * A white leaf on a solid green disc, not a bare green glyph — organic
 * packaging trends green, so a leaf drawn straight onto the packshot would
 * vanish against exactly the products it is meant to flag. The disc, with its
 * ring in the surface colour, guarantees the contrast whatever is behind it.
 *
 * It is purely decorative and carries `aria-hidden`: the fact is announced in
 * words elsewhere — the tile appends "biologisch" to its accessible name, and a
 * search row prints it in the grey sub-line — so a screen reader never meets the
 * leaf twice.
 *
 * One component, two sizes, because the same marker sits at two scales: on a
 * grid tile's large packshot (`tile`), and on a row's small thumbnail (`thumb` —
 * the shop-search results and the price-comparison rows), where it rides the
 * corner as a badge rather than being inset. Sharing it is what keeps the two
 * from drifting into two subtly different green leaves.
 */
export interface OrganicLeafProps {
  size?: 'tile' | 'thumb';
}

export function OrganicLeaf({ size = 'tile' }: OrganicLeafProps) {
  return (
    <span className={`organic-leaf organic-leaf-${size}`} aria-hidden="true">
      <svg viewBox="0 0 24 24" role="presentation">
        <path
          fill="currentColor"
          d="M6.05 8.05c-2.73 2.73-2.73 7.15-.02 9.88 1.47-3.4 4.09-6.24 7.36-7.93-2.77 2.34-4.71 5.61-5.39 9.32 2.6 1.23 5.8.78 7.95-1.37C19.43 14.47 20 4 20 4S9.53 4.57 6.05 8.05z"
        />
      </svg>
    </span>
  );
}
